import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterLink, RouterModule, Routes } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule } from "@angular/common/http";
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { IonicStorageModule } from '@ionic/storage-angular';

import { TitleCasePipe, DatePipe, CurrencyPipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DashboardPage } from './dashboard/dashboard.page';
import { ComentNoLaboraComponent } from '../app/components/coment-no-labora/coment-no-labora.component';
import { EditempPage } from './components/editemp/editemp.page';
import { NewempPage } from './components/newemp/newemp.page';
import { SearchciudadesPage } from './components/searchciudades/searchciudades.page';
import { DownloadreintegrosPage } from './components/downloadreintegros/downloadreintegros.page';
import { MenuConciliacionPage } from './components/menu-conciliacion/menu-conciliacion.page';
import { MenuNegarPage } from './components/menu-negar/menu-negar.page';

const routes: Routes = [
  { path: 'dashboard', component: DashboardPage },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    AppComponent,
    EditempPage,
    ComentNoLaboraComponent,
    EditempPage,
    NewempPage,
    SearchciudadesPage,
    DownloadreintegrosPage,
    MenuConciliacionPage,
    MenuNegarPage
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    NgxDatatableModule,
    IonicStorageModule.forRoot(),
    SharedModule,
    BrowserAnimationsModule,
    FormsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    RouterModule.forRoot(routes)
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    TitleCasePipe,
    DatePipe,
    CurrencyPipe,
    ComentNoLaboraComponent
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }